import gql from 'graphql-tag';

export default gql`
  mutation navigationOnBehalfUserMutation($_id: MongoID!, $course: MongoID, $sessionKey: String) {
    navigationOnBehalfUserMutation(_id: $_id, course: $course, sessionKey: $sessionKey) {
      title
      message
      sessionKey
    }
  }
`;
